import loadable from '@loadable/component';

export default loadable(
  () => import(/* webpackChunkName: "mweb-dealsplatform-page" */ './Container')
);
